<ng-template [ngIf]="showLoader">
    <div id="blocker" class="blocker">
        <div class="loader-container" style="height: 100vh;">
            <img src="../../../../assets/images/loader.gif" alt="loader gif">
        </div>
    </div>
</ng-template>

<ng-template [ngIf]="showSuccessLoader">
    <div id="blocker" class="blocker">
        <div class="loader-container" style="height: 100vh;">
            <img src="../../../../assets/images/loader.gif" alt="loader gif">
        </div>
    </div>
</ng-template>

<ng-template [ngIf]="showErrorLoader">
    <div id="blocker" class="blocker">
        <div class="loader-container" style="height: 100vh;">
            <img src="../../../../assets/images/loader.gif" alt="loader gif">
        </div>
    </div>
</ng-template>

<ng-template [ngIf]="showMailSendLoader">
    <div id="blocker" class="blocker">
        <div class="loader-container" style="height: 100vh;">
            <img src="../../../../assets/images/loader.gif" alt="loader gif">
        </div>
    </div>
</ng-template>